import { useContext } from 'react';

import { TwilioContext } from '../../../context-providers/TwilioContext';

type StatusColor = 'success' | 'danger' | 'warning';
type StatusText = 'Online' | 'Offline' | 'On a Call';

export const useHeaderStatus = () => {
  const { status, agentStatus } = useContext(TwilioContext);

  const getStatusColor = (): StatusColor => {
    switch (agentStatus) {
      case 'online':
        return 'success';
      case 'on-a-call':
        return 'warning';
      default:
        return 'danger';
    }
  };

  const formatStatus = (): StatusText => {
    switch (agentStatus) {
      case 'online':
        return 'Online';
      case 'on-a-call':
        return 'On a Call';
      default:
        return 'Offline';
    }
  };

  return {
    status,
    agentStatus,
    statusColor: getStatusColor(),
    statusText: formatStatus(),
  };
};
